import axios from 'axios'
import Validation from '../../../data/validation/validation'
import { StringValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from '../../../utils/UIHelper'
import { API_ENDPOINT } from '../../../config'

const getDefaultState = () => {
    return {
        resetting: false,
        tab: 0,
        password: "",
        password2: "",
        flag: {
            type: "",
            text: ""
        },
        showError: false,
        alertError: {},
        errors: {}
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.password, (error) => instance.state.errors.password = error, { min: { value: 6, error: "Invalid" }, max: { value: 40, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.password2, (error) => instance.state.errors.password2 = error, { min: { value: 6, error: "Invalid" }, max: { value: 40, error: "Invalid" } })
    let validate = validation.validate() && instance.state.password === instance.state.password2
    errors.password2 = instance.state.password === instance.state.password2 ? "" : "Password do not match"

    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Please fix the fields in red"
        }
    }
    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const reset = (instance) => {

    instance.setState({
        ...instance.state,
        resetting: true
    })

    let data = {
        token: instance.props.match.params.token,
        password: instance.state.password
    }
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/member/reset-password",
        data: data
    }).then(response => handleResetResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                resetting: true
            })
            alert(error)
        })
}

const handleResetResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                resetting: false,
                tab: 1
            })
            break
        default:
            instance.setState({
                ...instance.state,
                resetting: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const Worker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        reset: () => reset(instance)
    }
}

export default Worker